@use 'styles/functions/rem' as *;

.horizontalGridContainer {
    gap: inherit;
    grid-auto-flow: column;
}
